<template>
  <div class="container p-tb-2">
    <div class="row">
      <h1 class="m-10px"><p class="m-10px">Personal backoffice</p></h1>
      <div class="col-lg-12 col-xs-12">
        <Profile />
      </div>
      <div class="col-lg-3 col-xs-12 p-tb-2 xs-m-0 m-10px">
        <button type="button" class="rounded-5 button" @click="logout">Logout</button>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from 'Components/Profile';

export default {
  name: 'Backoffice',
  components: { Profile },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
  },
};
</script>
